export const rescueDetailNpoTour = {
  tourKey: 'rescue_detail_npo',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: null,
  },
  steps: [
    {
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail-npo-free.reassign.content',
      placement: 'center',
    },
    {
      target: '[data-tour="donation-chat-button"]',
      title: 'tours.donation-detail-npo-free.chat.title',
      content: 'tours.donation-detail-npo-free.chat.content',
      placement: 'bottom',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-chat-button"]')),
    },
    {
      target: '[data-tour="donation-cancel-button"]',
      title: 'tours.donation-detail-npo-free.cancel.title',
      content: 'tours.donation-detail-npo-free.cancel.content',
      placement: 'bottom',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-cancel-button"]')),
    },
  ],
};
